import { datalabWithTokenHttp, type TDatalabHttpConfig } from '@dbl/services/common';

import type { IGetMapLabelsResponseDto, IMapLabelsRequest } from './types';
/**
 * 获取地图地域中/英文名称映射，供 MapChart 等地域名称渲染使用。
 *
 * 无上传 prepare：请求体仅 `map_type`，直接传 wire。
 *
 * 原始实现：`src/pages/datalab/services/analysis.ts` -> getMapLabels
 * 原始引用（used-by）：
 * - `src/pages/datalab/components/CustomComponents/Chart/components/MapChart.tsx`
 */
export const getMapLabels = (
  params: IMapLabelsRequest,
): Promise<IGetMapLabelsResponseDto> =>
  datalabWithTokenHttp({
    url: '/api/v1/datalab/map/labels',
    method: 'post',
    data: params,
  } as TDatalabHttpConfig);
